module.exports = __webpack_public_path__ + "img/00_banner_qrcode.dcba2066.png";